module.exports = __webpack_public_path__ + "static/7-8b59a777c1a51f572e374c12fc5cd95c.jpeg";